import React, { useState, useCallback, useEffect } from 'react'
import { LegacyCard, Page, Layout } from '@shopify/polaris'
import styles from 'Styles/BookingDetails.scss'
import Loader from 'Components/Loader'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { useParams, useHistory } from 'react-router-dom'
import BookingActions from 'Redux/BookingRedux'

function CustomerBookingDetails(props) {
  const params = useParams()
  const history = useHistory()
  const dispatch = useDispatch()
  const [booking, setBooking] = useState({})
  const [isMultiDay, setIsMultiDay] = useState(false)
  let detailsFetching = useSelector((state) => state.booking.detailFetching)
  let cancelFetching = useSelector((state) => state.booking.cancelFetching)
  const settingsData = useSelector((state) => state.settings.data)

  let bookingData = useSelector((state) => state.booking.detailData)

  let customers =
    bookingData && bookingData.archived
      ? bookingData.archived_customers
      : bookingData.customers

  const uniqueEmails = new Set()
  let uniqueCustomers = []
  if (!!customers && customers.length > 0) {
    uniqueCustomers = customers.filter((customer) => {
      if (!uniqueEmails.has(customer.email)) {
        uniqueEmails.add(customer.email)
        return true
      }
      return false
    })
  }

  useEffect(() => {
    if (bookingData.id) {
      setBooking(bookingData)
      setIsMultiDay(bookingData.scenario === 'multi_day')
    }
  }, [bookingData])

  const isUpcomingBooking = () => {
    return moment(bookingData.selected_time).isAfter(moment())
  }

  useEffect(() => {
    if (params.id) {
      dispatch(BookingActions.bookingsDetailRequest(params.id))
    }
  }, [])

  const cancelAppointment = (customer) => () => {
    window.open(customer.cancel_uuid, '_blank')
  }

  const rescheduleAppointment = (customer) => () => {
    window.open(customer.reschedule_uuid, '_blank')
  }

  const getCardActions = (c) => {
    let actions = []
    if (bookingData.cancelled || bookingData.archived) {
      return []
    }

    if (isUpcomingBooking()) {
      if (c.reschedule_uuid) {
        actions.push({
          content: 'Reschedule',
          onAction: rescheduleAppointment(c),
        })
      }
      if (c.cancel_uuid) {
        actions.push({
          content: 'Cancel',
          onAction: cancelAppointment(c),
          destructive: true,
        })
      }
    }

    if (c.signpanda_cust_uuid) {
      actions.push({
        content: 'View Signed Pdf',
        onAction: viewPdf(c),
      })
    }

    return actions
  }

  return (
    <>
      {detailsFetching || !bookingData.id ? (
        <Loader />
      ) : (
        <Page
          fullWidth
          backAction={{
            content: 'Bookings',
            onAction: () => {
              history.push('/apps/customer_portal/upcoming_bookings')
            },
          }}
          title={booking.order_name}
        >
          <Layout>
            <Layout.Section variant="oneHalf">
              {!!uniqueCustomers &&
                uniqueCustomers.map((c, index) => {
                  return (
                    <LegacyCard
                      title={`Customer Details`}
                      actions={getCardActions(c)}
                      key={index}
                    >
                      <LegacyCard.Section title="Basic Info">
                        {c.name && <p translate="no">{c.name}</p>}
                        {c.email && <p translate="no">{c.email}</p>}
                        {c.payload?.phone && (
                          <p translate="no">{c.payload.phone}</p>
                        )}
                      </LegacyCard.Section>
                      {c.custom_fields && c.custom_fields.length > 0 && (
                        <LegacyCard.Section title="Custom Questions">
                          {c.custom_fields.map((cf, i) => {
                            if (!cf.value || !cf.label) return null
                            return (
                              <div>
                                <p>
                                  {i + 1}. {cf.label}
                                </p>
                                <p style={{ margin: '10px 20px' }}>
                                  {cf.value}
                                </p>
                              </div>
                            )
                          })}
                        </LegacyCard.Section>
                      )}
                    </LegacyCard>
                  )
                })}
            </Layout.Section>

            <Layout.Section variant="oneThird">
              <LegacyCard title="Service Details">
                <LegacyCard.Section title="Service Name">
                  <p>
                    {bookingData.variant_name
                      ? `${bookingData.variant_name}`
                      : bookingData.product_name}
                  </p>
                </LegacyCard.Section>
                <LegacyCard.Section title="Assigned Member">
                  <p>
                    {bookingData.team_member
                      ? `${bookingData.team_member.name}`
                      : 'Admin'}
                  </p>
                </LegacyCard.Section>
                <LegacyCard.Section title="Price">
                  <p>
                    {bookingData.currency} {bookingData.price}
                  </p>
                </LegacyCard.Section>
                {settingsData?.show_duration_in_email && (
                  <LegacyCard.Section
                    title={isMultiDay ? 'Start Date' : 'Duration'}
                  >
                    <p>
                      {isMultiDay
                        ? `${moment(bookingData.start_date).format(
                            'MMM Do YYYY'
                          )}`
                        : `${bookingData.duration} MINS`}
                    </p>
                  </LegacyCard.Section>
                )}
                <LegacyCard.Section title="Quantity">
                  <p>{customers?.length}</p>
                </LegacyCard.Section>
                <LegacyCard.Section
                  title={isMultiDay ? 'End Date' : 'Service Time'}
                >
                  <p>
                    {isMultiDay
                      ? `${moment(bookingData.end_date).format('MMM Do YYYY')}`
                      : moment(bookingData.selected_time).format('llll')}
                  </p>
                </LegacyCard.Section>
                {bookingData.meeting_detail && (
                  <LegacyCard.Section title="Meeting Details">
                    <p>{bookingData.meeting_detail}</p>
                  </LegacyCard.Section>
                )}
                {bookingData.note && (
                  <LegacyCard.Section title="Note">
                    <p>{bookingData.note}</p>
                  </LegacyCard.Section>
                )}
                {bookingData.location_type && bookingData.location_value && (
                  <LegacyCard.Section title={bookingData.location_type}>
                    {bookingData.location_value}
                  </LegacyCard.Section>
                )}
              </LegacyCard>
            </Layout.Section>
          </Layout>
        </Page>
      )}
    </>
  )
}

export default CustomerBookingDetails
